import React from 'react';
import { useDeviceInitialization } from '../hooks/useDeviceInitialization';

interface DeviceProviderProps {
    children: React.ReactNode;
}

export const DeviceProvider: React.FC<DeviceProviderProps> = ({ children }) => {
    const { isInitialized } = useDeviceInitialization();

    // Show loading until device is initialized
    if (!isInitialized) {
        return <div>Initializing device...</div>;
    }

    return <>{children}</>;
};
